var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewExtractorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.5,
    fill: "white",
    stroke: "#EAEAEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 23.05V18.5H24.5V23.05C23.8 23.25 23.25 23.8 23.05 24.5H18.5V25.5H23.05C23.25 26.35 24.05 27 25 27C26.1 27 27 26.1 27 25C27 24.05 26.35 23.3 25.5 23.05ZM25 26C24.45 26 24 25.55 24 25C24 24.45 24.45 24 25 24C25.55 24 26 24.45 26 25C26 25.55 25.55 26 25 26ZM17 27H13V23H17V27ZM14 26H16V24H14V26ZM16.95 15.5H21.5V14.5H16.95C16.7 13.65 15.95 13 15 13C13.9 13 13 13.9 13 15C13 15.95 13.65 16.7 14.5 16.95V21.5H15.5V16.95C16.2 16.75 16.75 16.2 16.95 15.5ZM15 16C14.45 16 14 15.55 14 15C14 14.45 14.45 14 15 14C15.55 14 16 14.45 16 15C16 15.55 15.55 16 15 16Z",
    fill: "#6D6E7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 13V14H25.3L17.5 21.8L18.2 22.5L26 14.7V17H27V13H23Z",
    fill: "#6D6E7C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewExtractorIcon);
export default __webpack_public_path__ + "static/media/new-extractor-icon.688e0514127f5a4b89226ab74da5fbd1.svg";
export { ForwardRef as ReactComponent };